export const formatReleaseDate = (releaseDate: string) => new Date(releaseDate).getFullYear();
